import React from 'react';
import PropTypes from 'prop-types';
import { getResourceTo } from 'react/utils/utils';
import chatTicketActions from 'react/api/actions/chatTicketActions';

import { connect } from 'react-redux';
import resources from './resources';
import TicketHubListItem from './TicketHubListItem';

const TicketList = ({
  tickets,
  acceptTicketAction,
  toggleModalReassignTicket,
  seeTicketInWindow,
  userId
}) => {
  if (!tickets?.size) {
    return (
      <div className="ticketHub__list-notFound">
        {getResourceTo(resources.dataNotFound)}
      </div>
    );
  }

  return (
    <div className="ticketHub__list-tickets">
      {tickets.map((ticket) => (
        <TicketHubListItem
          key={ticket.get('id')}
          userId={userId}
          ticket={ticket}
          acceptTicketAction={acceptTicketAction}
          toggleModalReassignTicket={toggleModalReassignTicket}
          seeTicketInWindow={seeTicketInWindow}
        />
      ))}
    </div>
  );
};


TicketList.propTypes = {
  tickets: PropTypes.object.isRequired,
  acceptTicketAction: PropTypes.func.isRequired,
  toggleModalReassignTicket: PropTypes.func.isRequired,
  seeTicketInWindow: PropTypes.func.isRequired,
  userId: PropTypes.number
};

TicketList.defaultProps = {
  userId: 0
};

const mapStateToProps = ({ configuration }) => ({
  userId: configuration?.loggedUser?.id
});

const mapDispatchToProps = {
  acceptTicketAction: chatTicketActions.actionCreators.submitAcceptCall,
  toggleModalReassignTicket: chatTicketActions.actionCreators.toggleReassignCallModal,
  seeTicketInWindow: chatTicketActions.actionCreators.seeTicketInWindow
};

export default connect(mapStateToProps, mapDispatchToProps)(TicketList);
